import { useContext } from 'react';
import { useRemirrorContext } from '@remirror/react';
import { useMutation } from '@tanstack/react-query';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import type * as API from '@trinity/chat/api/interfaces';
import { RefetchTranscriptContext } from '@/containers/Transcript/context';

type UseEditSpeakerMutationProps = {
  onSuccess?: () => void;
} & ITranscriptId;

export const useEditSpeakerSelectionMutation = ({ onSuccess, transcriptId }: UseEditSpeakerMutationProps) => {
  const refetch = useContext(RefetchTranscriptContext);
  const { manager } = useRemirrorContext();

  const apiClient = useChatApiClient();

  const mutation = useMutation<M.Res, M.E, M.Req>({
    mutationKey: [
      `put:transcripts/speakers/selection`,
      transcriptId,
    ],
    mutationFn: params => {
      return apiClient.transcripts.updateTranscriptSpeakerSelection({
        speakerIndex: params.speakerIndex,
        transcriptId,
        ts: {
          end: params.end,
          start: params.start,
        },
      })
        .then(async data => {
          const res = await refetch();

          manager.view.updateState(manager.createState({
            content: res.transcript.document,
          }));

          onSuccess?.();

          return data;
        });
    },
  });

  return mutation;
};

namespace M {
  export type Res = API.Transcripts.UpdateTranscriptSpeakerSelection.Response;
  export type E = unknown;
  export type Req = {
    end: number;
    speakerIndex: number;
    start: number;
  };
}